import Cookies from 'universal-cookie';

const cookies = new Cookies();

/**
 * Get a cookie by name
 * @param {string} name - Cookie name
 * @returns {string | undefined}
 */
const get = (name: string) => cookies.get(name);

/** Secure only in production (HTTPS). In dev (e.g. http://localhost) secure would block the cookie. */
const isSecure = process.env['NX_ENV'] === 'production';

/**
 * Set a cookie with a name, value, and optional expiration.
 * Defaults: secure (prod only), sameSite: 'strict' to reduce XSS/CSRF surface.
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {object} options - Additional cookie options (e.g., expires, path, domain)
 */
const set = (name: string, value: string, options: object = {}) => {
  cookies.set(name, value, {
    path: '/',
    domain: process.env['NX_DOMAIN_NAME'],
    secure: isSecure,
    sameSite: 'strict',
    ...options,
  });
};

/**
 * Remove a cookie by name (options must match set() for same path/domain)
 * @param {string} name - Cookie name
 * @param {object} options - Additional cookie options (e.g., path, domain)
 */
const remove = (name: string, options: object = {}) => {
  cookies.remove(name, {
    path: '/',
    domain: process.env['NX_DOMAIN_NAME'],
    ...options,
  });
};

/**
 * Check if a cookie exists
 * @param {string} name - Cookie name
 * @returns {boolean}
 */
const exists = (name: string) => !!cookies.get(name);

export const cookiesHelper = { get, set, remove, exists };
